var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVibTab2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 91,
    viewBox: "0 0 115 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.693 64.0104V74.677C122.693 92.3501 96.4267 106.677 64.0261 106.677C32.204 106.677 6.29943 92.8573 5.38439 75.6205L5.35938 74.677V64.0104C5.35938 81.6834 31.6253 96.0104 64.0261 96.0104C96.4267 96.0104 122.693 81.6834 122.693 64.0104ZM64.0261 21.3438C96.4267 21.3438 122.693 35.6706 122.693 53.3437C122.693 71.0168 96.4267 85.3437 64.0261 85.3437C31.6253 85.3437 5.35938 71.0168 5.35938 53.3437C5.35938 35.6706 31.6253 21.3438 64.0261 21.3438Z",
    fill: "#194CA0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibTab2Icon);
export default __webpack_public_path__ + "static/media/vib-tab-2-icon.1e4b8cb5d3649ddc8736f330c664a305.svg";
export { ForwardRef as ReactComponent };